export const slots = [
  'head',
  'neck',
  'shoulder',
  'back',
  'chest',
  'waist',
  'shirt',
  'wrist',
  'hands',
  'legs',
  'feet',
  'finger1',
  'finger2',
  'trinket1',
  'trinket2',
  'mainhand',
  'offhand'
]
export type ItemSlot = (typeof slots)[number]
